(function () {
   'use strict';

   var NAV_ACTIVE_SCOPE = '.header.header-shell, .mega-panel, .simular-dropdown, .header-mobile-drawer';
   var SIMULAR_PANEL_ID = 'simularEmprestimoPanel';
   var HEADER_SIMULAR_BTN_ID = 'headerSimularBtn';
   var DESKTOP_XL_QUERY = '(min-width: 1200px)';

   function ensureSimularPanelPlacement(doc) {
      var header = doc.querySelector('.header.header-shell');
      var panel = doc.getElementById(SIMULAR_PANEL_ID);
      if (!header || !panel || !header.parentNode) return;
      if (!header.contains(panel)) return;
      header.parentNode.insertBefore(panel, header.nextSibling);
   }

   function syncSimularDropdownPosition(doc) {
      var panel = doc.getElementById(SIMULAR_PANEL_ID);
      var btn = doc.getElementById(HEADER_SIMULAR_BTN_ID);
      if (!panel) return;

      if (panel.hidden || !window.matchMedia(DESKTOP_XL_QUERY).matches) {
         panel.style.removeProperty('right');
         panel.style.removeProperty('left');
         panel.style.removeProperty('top');
         return;
      }

      if (!btn) return;

      var rect = btn.getBoundingClientRect();
      panel.style.right = Math.max(12, window.innerWidth - rect.right) + 'px';
      panel.style.left = 'auto';
      panel.style.top = rect.bottom + 'px';
   }

   function normalizePath(path) {
      if (!path) return '/';
      path = String(path).split('?')[0];
      if (path.length > 1 && path.charAt(path.length - 1) === '/') {
         path = path.slice(0, -1);
      }
      return path.toLowerCase();
   }

   function getLocationKey() {
      return {
         path: normalizePath(window.location.pathname),
         hash: window.location.hash ? window.location.hash.toLowerCase() : '',
      };
   }

   function parseNavHref(href) {
      if (!href || href.charAt(0) === '#') return null;
      try {
         var url = new URL(href, window.location.origin);
         if (url.origin !== window.location.origin) return null;
         return {
            path: normalizePath(url.pathname),
            hash: url.hash ? url.hash.toLowerCase() : '',
         };
      } catch (e) {
         return null;
      }
   }

   function scoreNavMatch(href, loc) {
      var parsed = parseNavHref(href);
      if (!parsed) return -1;

      if (parsed.hash) {
         return parsed.path === loc.path && parsed.hash === loc.hash ? 2000 + parsed.path.length : -1;
      }

      if (parsed.path === loc.path) {
         return loc.hash ? 100 + parsed.path.length : 1000 + parsed.path.length;
      }

      if (loc.path.indexOf(parsed.path + '/') === 0) {
         return 500 + parsed.path.length;
      }

      return -1;
   }

   function clearNavActiveState(doc) {
      var scope = doc.querySelector(NAV_ACTIVE_SCOPE);
      if (!scope) return;

      var root = doc.body;
      var navLinks = root.querySelectorAll('.header-nav__link.is-active');
      for (var i = 0; i < navLinks.length; i++) {
         navLinks[i].classList.remove('is-active');
      }

      var currents = root.querySelectorAll(
         '.mega-panel__link--current, .mega-panel__sublink.is-active, .header-mobile-drawer__sub-body a.is-active, .header-mobile-drawer__link.is-active'
      );
      for (var c = 0; c < currents.length; c++) {
         currents[c].classList.remove('is-active', 'mega-panel__link--current');
      }

      var summaries = root.querySelectorAll(
         '.header-mobile-drawer__summary.is-active, .header-mobile-drawer__sub-summary.is-active'
      );
      for (var s = 0; s < summaries.length; s++) {
         summaries[s].classList.remove('is-active');
      }

      var subdetailTriggers = root.querySelectorAll('[data-subdetail-target].is-active');
      for (var t = 0; t < subdetailTriggers.length; t++) {
         subdetailTriggers[t].classList.remove('is-active');
         subdetailTriggers[t].setAttribute('aria-expanded', 'false');
      }

      var ariaCurrent = root.querySelectorAll(
         '.header-nav__link[aria-current="page"], .mega-panel [aria-current="page"], .header-mobile-drawer [aria-current="page"]'
      );
      for (var a = 0; a < ariaCurrent.length; a++) {
         ariaCurrent[a].removeAttribute('aria-current');
      }
   }

   function markNavLinkActive(link) {
      if (!link) return;
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'page');
      if (link.classList.contains('mega-panel__link')) {
         link.classList.add('mega-panel__link--current');
      }
   }

   function getBestNavMatchScore(links, loc) {
      var bestScore = -1;
      for (var i = 0; i < links.length; i++) {
         var score = scoreNavMatch(links[i].getAttribute('href'), loc);
         if (score > bestScore) bestScore = score;
      }
      return bestScore;
   }

   function markBestMatchingLinks(links, loc, skipLink, scoreFn) {
      var bestScore = -1;
      for (var i = 0; i < links.length; i++) {
         var currentScore = scoreFn ? scoreFn(links[i]) : scoreNavMatch(links[i].getAttribute('href'), loc);
         if (currentScore > bestScore) bestScore = currentScore;
      }
      if (bestScore < 0) return;

      for (var j = 0; j < links.length; j++) {
         var link = links[j];
         if (skipLink && skipLink(link)) continue;
         var matchScore = scoreFn ? scoreFn(link) : scoreNavMatch(link.getAttribute('href'), loc);
         if (matchScore === bestScore) {
            markNavLinkActive(link);
         }
      }
   }

   function isOverviewMegaView(view) {
      return !!(view && view.querySelector('.mega-panel__quick'));
   }

   function isQuickAccessLink(link) {
      return !!(link && link.closest('.mega-panel__quick'));
   }

   function isStandaloneMegaSidebarLink(link) {
      if (!link || !link.closest('.mega-panel__sidebar')) return false;
      if (link.hasAttribute('data-mega-back')) return false;
      if (link.hasAttribute('data-mega-view-id')) return false;
      if (link.hasAttribute('data-mega-detail')) return false;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return false;
      return true;
   }

   function findStandaloneOverviewMatch(panel, loc) {
      if (!panel) return null;
      var views = panel.querySelectorAll('.mega-panel__view');
      for (var i = 0; i < views.length; i++) {
         if (!isOverviewMegaView(views[i])) continue;
         var links = views[i].querySelectorAll('.mega-panel__sidebar a[href]');
         for (var j = 0; j < links.length; j++) {
            var link = links[j];
            if (!isStandaloneMegaSidebarLink(link)) continue;
            var score = scoreNavMatch(link.getAttribute('href'), loc);
            if (score >= 0) {
               return { panel: panel, view: views[i], link: link, bestScore: score };
            }
         }
      }
      return null;
   }

   function scoreMegaPanelLinkMatch(link, view, loc) {
      if (!link || isQuickAccessLink(link)) return -1;
      if (isStandaloneMegaSidebarLink(link) && !isOverviewMegaView(view)) return -1;

      var score = scoreNavMatch(link.getAttribute('href'), loc);
      if (score < 0) return -1;
      if (!isOverviewMegaView(view)) score += 10;
      if (link.classList.contains('mega-panel__sublink')) score += 5;
      return score;
   }

   function resolveMegaPanelView(panel, view, link, loc) {
      if (link && isStandaloneMegaSidebarLink(link)) {
         var overviewViews = panel.querySelectorAll('.mega-panel__view');
         for (var o = 0; o < overviewViews.length; o++) {
            if (isOverviewMegaView(overviewViews[o])) return overviewViews[o];
         }
      }

      if (link) {
         var viewFromLink = link.closest('.mega-panel__view');
         if (viewFromLink && panel.contains(viewFromLink)) {
            return viewFromLink;
         }
      }

      if (!link || !panel || !view) return view;

      var viewId = link.getAttribute('data-mega-view-id');
      if (viewId) {
         var explicitView = panel.querySelector('#' + viewId);
         if (explicitView) return explicitView;
      }

      if (isOverviewMegaView(view)) {
         var href = link.getAttribute('href');
         if (href && href.charAt(0) !== '#') {
            var detailViews = panel.querySelectorAll('.mega-panel__view');
            for (var i = 0; i < detailViews.length; i++) {
               if (isOverviewMegaView(detailViews[i])) continue;
               var detailLinks = detailViews[i].querySelectorAll('a[href]');
               for (var d = 0; d < detailLinks.length; d++) {
                  if (scoreNavMatch(detailLinks[d].getAttribute('href'), loc) >= 0) {
                     return detailViews[i];
                  }
               }
            }
         }
      }

      return view;
   }

   var MEGA_PANEL_ROUTE_HINTS = [
      { pathPrefix: '/autocontratacao-inss', panelId: 'megaParaVoce', viewId: 'megaViewInss' },
      { pathPrefix: '/lp/credito-trabalhador', panelId: 'megaParaVoce', viewId: 'megaViewCdt' },
      { pathPrefix: '/consignado-inss', panelId: 'megaParaVoce', viewId: 'megaViewInss' },
      { pathPrefix: '/consignado-publico', panelId: 'megaParaVoce', viewId: 'megaViewPublico' },
      { pathPrefix: '/emprestimo-saque-aniversario-fgts', panelId: 'megaParaVoce', viewId: 'megaViewFgts' },
   ];

   function findMegaPanelContextFromHint(doc, loc) {
      for (var h = 0; h < MEGA_PANEL_ROUTE_HINTS.length; h++) {
         var hint = MEGA_PANEL_ROUTE_HINTS[h];
         if (
            loc.path === hint.pathPrefix ||
            loc.path.indexOf(hint.pathPrefix + '/') === 0
         ) {
            var panel = doc.getElementById(hint.panelId);
            var view = doc.getElementById(hint.viewId);
            if (panel && view) {
               return { panel: panel, view: view, link: null, bestScore: 1000 };
            }
         }
      }
      return null;
   }

   function findMegaPanelContext(doc, loc) {
      var best = null;
      var bestScore = -1;
      var panels = doc.querySelectorAll('.mega-panel');

      for (var sp = 0; sp < panels.length; sp++) {
         var standaloneMatch = findStandaloneOverviewMatch(panels[sp], loc);
         if (standaloneMatch && standaloneMatch.bestScore > bestScore) {
            bestScore = standaloneMatch.bestScore;
            best = standaloneMatch;
         }
      }
      if (best) return best;

      for (var p = 0; p < panels.length; p++) {
         var panel = panels[p];
         var views = panel.querySelectorAll('.mega-panel__view');
         for (var v = 0; v < views.length; v++) {
            var view = views[v];
            var links = view.querySelectorAll('a[href]');
            for (var i = 0; i < links.length; i++) {
               var link = links[i];
               var score = scoreMegaPanelLinkMatch(link, view, loc);
               if (score > bestScore) {
                  bestScore = score;
                  best = {
                     panel: panel,
                     view: resolveMegaPanelView(panel, view, link, loc),
                     link: link,
                     bestScore: score,
                  };
               }
            }
         }
      }

      return bestScore >= 0 ? best : null;
   }

   function activateSubDetailHierarchy(view, loc) {
      if (!view) return;

      var subDetails = view.querySelectorAll('.mega-panel__sub-detail');
      for (var i = 0; i < subDetails.length; i++) {
         subDetails[i].hidden = true;
      }

      var subTriggers = view.querySelectorAll('[data-subdetail-target]');
      for (var t = 0; t < subTriggers.length; t++) {
         subTriggers[t].classList.remove('is-active');
         subTriggers[t].setAttribute('aria-expanded', 'false');
      }

      var bestSubDetail = null;
      var bestSubScore = -1;
      for (var d = 0; d < subDetails.length; d++) {
         var detail = subDetails[d];
         var detailLinks = detail.querySelectorAll('a[href]');
         var detailScore = getBestNavMatchScore(detailLinks, loc);
         if (detailScore > bestSubScore) {
            bestSubScore = detailScore;
            bestSubDetail = detail;
         }
      }

      if (!bestSubDetail || bestSubScore < 0) return;

      bestSubDetail.hidden = false;
      var subId = bestSubDetail.id;
      var trigger = view.querySelector('[data-subdetail-target="' + subId + '"]');
      if (trigger) {
         trigger.classList.add('is-active');
         trigger.setAttribute('aria-expanded', 'true');
      }
   }

   function activateMegaPanelContext(doc, ctx, loc) {
      var panel = ctx.panel;
      var view = ctx.view;
      var trigger = doc.querySelector('[data-mega-target="' + panel.id + '"]');
      if (trigger) trigger.classList.add('is-active');

      setMegaPanelDefaultView(panel, view.id);

      var productLink =
         view.querySelector('.mega-panel__sidebar [data-mega-back]') ||
         view.querySelector('.mega-panel__sidebar .mega-panel__link--current');
      if (productLink) {
         markNavLinkActive(productLink);
      }

      var viewLinks = view.querySelectorAll('a[href]');
      markBestMatchingLinks(viewLinks, loc, function (link) {
         return link === productLink;
      }, function (link) {
         return scoreMegaPanelLinkMatch(link, view, loc);
      });

      activateSubDetailHierarchy(view, loc);
   }

   function setMegaPanelDefaultView(panel, viewId) {
      if (!panel || !viewId) return;
      var views = panel.querySelectorAll('.mega-panel__view');
      for (var i = 0; i < views.length; i++) {
         views[i].hidden = views[i].id !== viewId;
      }
      panel.setAttribute('data-active-view', viewId);
   }

   function isMegaPanelParentTrigger(link) {
      if (!link) return false;
      return (
         link.hasAttribute('data-mega-detail') ||
         link.hasAttribute('data-mega-back')
      );
   }

   function markMegaPanelSidebarSelection(panel, viewId) {
      if (!panel || !viewId) return;
      var view = document.getElementById(viewId);
      if (!view || !panel.contains(view)) return;

      var sidebarLinks = panel.querySelectorAll('.mega-panel__sidebar .mega-panel__link');
      for (var i = 0; i < sidebarLinks.length; i++) {
         sidebarLinks[i].classList.remove('mega-panel__link--current', 'is-active');
         sidebarLinks[i].removeAttribute('aria-current');
      }

      var activeLink =
         view.querySelector('.mega-panel__sidebar [data-mega-back]') ||
         view.querySelector('.mega-panel__sidebar [data-mega-detail]');
      if (activeLink) markNavLinkActive(activeLink);
   }

   function captureOpenMegaPanelNavState(doc) {
      var preserved = [];
      var panels = doc.querySelectorAll('.mega-panel:not([hidden])');
      for (var i = 0; i < panels.length; i++) {
         var panel = panels[i];
         if (panel.getAttribute('data-user-navigated') !== 'true') continue;
         var viewId = panel.getAttribute('data-active-view');
         if (!viewId) continue;
         preserved.push({ panel: panel, viewId: viewId });
      }
      return preserved;
   }

   function restoreOpenMegaPanelNavState(preserved) {
      for (var i = 0; i < preserved.length; i++) {
         var entry = preserved[i];
         if (!entry.panel || !entry.viewId) continue;
         setMegaPanelDefaultView(entry.panel, entry.viewId);
         markMegaPanelSidebarSelection(entry.panel, entry.viewId);
      }
   }

   function getMegaPanelDefaultViewId(panel) {
      if (!panel) return '';
      var views = panel.querySelectorAll('.mega-panel__view');
      for (var i = 0; i < views.length; i++) {
         if (isOverviewMegaView(views[i])) return views[i].id;
      }
      return views[0] ? views[0].id : '';
   }

   function clearMegaPanelSelection(panel) {
      if (!panel) return;

      var sidebarLinks = panel.querySelectorAll('.mega-panel__sidebar .mega-panel__link');
      for (var i = 0; i < sidebarLinks.length; i++) {
         sidebarLinks[i].classList.remove('mega-panel__link--current', 'is-active');
         sidebarLinks[i].removeAttribute('aria-current');
      }

      var sublinks = panel.querySelectorAll('.mega-panel__sublink.is-active');
      for (var s = 0; s < sublinks.length; s++) {
         sublinks[s].classList.remove('is-active');
      }

      resetSubDetailsInPanel(panel);
   }

   function resetSubDetailsInPanel(panel) {
      if (!panel) return;
      var details = panel.querySelectorAll('.mega-panel__sub-detail');
      for (var d = 0; d < details.length; d++) details[d].hidden = true;
      var subTriggers = panel.querySelectorAll('[data-subdetail-target]');
      for (var t = 0; t < subTriggers.length; t++) {
         subTriggers[t].classList.remove('is-active');
         subTriggers[t].setAttribute('aria-expanded', 'false');
      }
   }

   function findMegaPanelContextForPanel(doc, panel, loc) {
      var megaContext = findMegaPanelContext(doc, loc);
      if (!megaContext) megaContext = findMegaPanelContextFromHint(doc, loc);
      if (megaContext && megaContext.panel === panel) return megaContext;
      return null;
   }

   function resetMegaPanelToInitialState(panel, doc) {
      if (!panel) return;
      panel.removeAttribute('data-user-navigated');

      var loc = getLocationKey();
      var panelContext = findMegaPanelContextForPanel(doc, panel, loc);
      if (panelContext && panelContext.view) {
         setMegaPanelDefaultView(panel, panelContext.view.id);
      } else {
         var defaultViewId = getMegaPanelDefaultViewId(panel);
         if (defaultViewId) setMegaPanelDefaultView(panel, defaultViewId);
      }

      clearMegaPanelSelection(panel);
   }

   function syncOpenMegaPanelBaseline(panel, doc) {
      if (!panel || panel.hidden || panel.getAttribute('data-user-navigated') === 'true') return;

      var loc = getLocationKey();
      var panelContext = findMegaPanelContextForPanel(doc, panel, loc);
      if (panelContext && panelContext.view) return;

      var defaultViewId = getMegaPanelDefaultViewId(panel);
      if (defaultViewId) setMegaPanelDefaultView(panel, defaultViewId);
      clearMegaPanelSelection(panel);
   }

   function activateMobileDrawerHierarchy(link) {
      var subBody = link.closest('.header-mobile-drawer__sub-body');
      if (!subBody) return;

      var node = subBody.parentElement;
      while (node && node.classList && !node.classList.contains('header-mobile-drawer__nav')) {
         if (node.classList.contains('header-mobile-drawer__sub')) {
            var subSummary = node.querySelector(':scope > .header-mobile-drawer__sub-summary');
            if (subSummary) subSummary.classList.add('is-active');
         }
         if (node.classList.contains('header-mobile-drawer__group')) {
            var groupSummary = node.querySelector(':scope > .header-mobile-drawer__summary');
            if (groupSummary) groupSummary.classList.add('is-active');
         }
         node = node.parentElement;
      }
   }

   var navActiveStateTimer = null;

   function scheduleNavActiveState(doc) {
      if (navActiveStateTimer) window.clearTimeout(navActiveStateTimer);
      navActiveStateTimer = window.setTimeout(function () {
         navActiveStateTimer = null;
         applyNavActiveState(doc || document);
      }, 0);
   }

   function observeDynamicNav(doc) {
      if (typeof MutationObserver === 'undefined') return;

      var targets = [
         doc.querySelector('.header-nav'),
         doc.querySelector('.header-aside__simular'),
         doc.querySelector('[data-mobile-nav-target]'),
      ];

      for (var i = 0; i < targets.length; i++) {
         var target = targets[i];
         if (!target) continue;
         new MutationObserver(function () {
            ensureSimularPanelPlacement(doc);
            scheduleNavActiveState(doc);
         }).observe(target, { childList: true, subtree: true });
      }
   }

   function applyNavActiveState(rootDoc) {
      var doc = rootDoc || document;
      if (!doc.querySelector('.header.header-shell')) return;

      var preservedPanelNav = captureOpenMegaPanelNavState(doc);

      clearNavActiveState(doc);
      var loc = getLocationKey();

      var topNav = doc.querySelector('.header-nav');
      var topDirectLinks = topNav ? topNav.querySelectorAll('a.header-nav__link[href]') : [];
      var topBestScore = getBestNavMatchScore(topDirectLinks, loc);

      var megaContext = findMegaPanelContext(doc, loc);
      if (!megaContext) {
         megaContext = findMegaPanelContextFromHint(doc, loc);
      }
      var megaBestScore = megaContext ? megaContext.bestScore : -1;
      var useTopNavOnly = topBestScore >= 0 && topBestScore >= megaBestScore;

      if (useTopNavOnly) {
         markBestMatchingLinks(topDirectLinks, loc);
      } else if (megaContext) {
         activateMegaPanelContext(doc, megaContext, loc);
      }

      var mobileNav = doc.querySelector('.header-mobile-drawer__nav');
      if (mobileNav) {
         if (useTopNavOnly) {
            var mobileTopLinks = mobileNav.querySelectorAll(':scope > a.header-mobile-drawer__link[href]');
            markBestMatchingLinks(mobileTopLinks, loc);
         } else {
            var mobileLinks = mobileNav.querySelectorAll('a[href]');
            var bestMobileScore = getBestNavMatchScore(mobileLinks, loc);
            if (bestMobileScore >= 0) {
               for (var m = 0; m < mobileLinks.length; m++) {
                  if (scoreNavMatch(mobileLinks[m].getAttribute('href'), loc) === bestMobileScore) {
                     markNavLinkActive(mobileLinks[m]);
                     activateMobileDrawerHierarchy(mobileLinks[m]);
                  }
               }
            }
         }
      }

      restoreOpenMegaPanelNavState(preservedPanelNav);
   }

   function init() {
      var doc = document;
      var refreshMobileProductsCarousels = function () {};

      var els = {
         body: doc.body,
         overlay: doc.getElementById('headerOverlay'),
         mobileToggle: doc.getElementById('headerMobileToggle'),
         mobileDrawer: doc.getElementById('headerMobileDrawer'),
         mobileClose: doc.getElementById('headerMobileClose'),
         headerShell: doc.querySelector('.header.header-shell'),
         searchBar: doc.querySelector('.header-search-bar'),
         searchInput: doc.getElementById('headerSearchBarInput'),
      };

      function hydrateTemplate(templateId, targetSelector) {
         var template = doc.getElementById(templateId);
         var target = doc.querySelector(targetSelector);
         if (!template || !target || target.children.length > 0) return;
         target.appendChild(template.content.cloneNode(true));
      }

      hydrateTemplate('headerMobileNavTemplate', '[data-mobile-nav-target]');

      var panels = [];
      var boundPanelInteractions = {};

      function updateOverlay() {
         if (!els.overlay) return;
         var anyOpen = false;
         var seenPanels = {};
         for (var o = 0; o < panels.length; o++) {
            var openPanel = panels[o].panel;
            if (!openPanel || seenPanels[openPanel.id]) continue;
            seenPanels[openPanel.id] = true;
            if (!openPanel.hidden) {
               anyOpen = true;
               break;
            }
         }
         var drawerOpen = els.mobileDrawer && !els.mobileDrawer.hidden;
         els.overlay.hidden = !(anyOpen || drawerOpen);
      }

      function setPanelOpen(target, open) {
         if (!target || !target.panel || !target.btn) return;

         if (open) {
            target.btn.classList.add('is-open');
            target.btn.setAttribute('aria-expanded', 'true');
            target.panel.hidden = false;
            target.panel.setAttribute('aria-hidden', 'false');
            if (target.panel.id === SIMULAR_PANEL_ID) {
               ensureSimularPanelPlacement(doc);
               syncSimularDropdownPosition(doc);
               requestAnimationFrame(function () {
                  syncSimularDropdownPosition(doc);
               });
            }
            applyNavActiveState(doc);
            syncOpenMegaPanelBaseline(target.panel, doc);
         } else {
            for (var i = 0; i < panels.length; i++) {
               var entry = panels[i];
               if (entry.panel !== target.panel || !entry.btn) continue;
               entry.btn.classList.remove('is-open');
               entry.btn.setAttribute('aria-expanded', 'false');
            }
            target.panel.hidden = true;
            target.panel.setAttribute('aria-hidden', 'true');
            resetMegaPanelToInitialState(target.panel, doc);
            applyNavActiveState(doc);
         }

         updateOverlay();
      }

      function closeAllPanels(except) {
         var exceptPanel = except && except.panel;
         var closedPanels = {};

         for (var i = 0; i < panels.length; i++) {
            var p = panels[i];
            if (except && p.btn === except.btn) continue;

            if (p.btn && p.btn.classList.contains('is-open')) {
               p.btn.classList.remove('is-open');
               p.btn.setAttribute('aria-expanded', 'false');
            }

            if (!p.panel || (exceptPanel && p.panel === exceptPanel)) continue;

            var panelId = p.panel.id;
            if (!panelId || closedPanels[panelId]) continue;
            closedPanels[panelId] = true;

            if (!p.panel.hidden) setPanelOpen(p, false);
         }

         updateOverlay();
      }

      function bindPanelInteractions(panel) {
         if (!panel || boundPanelInteractions[panel.id]) return;
         boundPanelInteractions[panel.id] = true;

         panel.addEventListener('click', function (e) {
            e.stopPropagation();
         });

         panel.addEventListener('click', function (e) {
            if (e.target.closest('[data-mega-close]')) {
               for (var c = 0; c < panels.length; c++) {
                  if (panels[c].panel === panel) setPanelOpen(panels[c], false);
               }
               return;
            }

            var detail = e.target.closest('[data-mega-detail]');
            if (detail) {
               e.preventDefault();
               var key = detail.getAttribute('data-mega-detail');
               var explicit = detail.getAttribute('data-mega-view-id');
               var viewId = explicit || 'megaView' + key.charAt(0).toUpperCase() + key.slice(1);
               showMegaView(panel, viewId);
               return;
            }

            var megaParent = e.target.closest('.mega-panel__sidebar [data-mega-back]');
            if (megaParent) {
               e.preventDefault();
               return;
            }

            var subTrigger = e.target.closest('[data-subdetail-target]');
            if (subTrigger) {
               e.preventDefault();
               var view = subTrigger.closest('.mega-panel__view') || panel;
               var subId = subTrigger.getAttribute('data-subdetail-target');
               var wasActive = subTrigger.getAttribute('aria-expanded') === 'true';
               resetSubDetails(view);
               if (!wasActive) {
                  var subEl = view.querySelector('#' + subId);
                  if (subEl) subEl.hidden = false;
                  subTrigger.classList.add('is-active');
                  subTrigger.setAttribute('aria-expanded', 'true');
               }
               return;
            }

            var realLink = e.target.closest('a[href]');
            if (realLink && panel.contains(realLink)) {
               if (isMegaPanelParentTrigger(realLink)) {
                  e.preventDefault();
                  return;
               }
               var linkHref = realLink.getAttribute('href');
               if (linkHref && linkHref.charAt(0) !== '#') {
                  for (var l = 0; l < panels.length; l++) {
                     if (panels[l].panel === panel) setPanelOpen(panels[l], false);
                  }
               } else {
                  e.preventDefault();
               }
            }
         });
      }

      function bindPanelTrigger(btn, panel) {
         if (!btn || !panel) return;
         if (btn.getAttribute('data-mega-bound') === panel.id) return;

         btn.setAttribute('data-mega-bound', panel.id);

         var target = { btn: btn, panel: panel };
         panels.push(target);
         bindPanelInteractions(panel);

         btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var willOpen = target.panel.hidden || !target.btn.classList.contains('is-open');
            closeAllPanels(target);
            setPanelOpen(target, willOpen);
         });
      }

      function scanPanelTriggers() {
         ensureSimularPanelPlacement(doc);

         var triggers = doc.querySelectorAll('[data-mega-target]');
         for (var t = 0; t < triggers.length; t++) {
            var triggerBtn = triggers[t];
            var panel = doc.getElementById(triggerBtn.getAttribute('data-mega-target'));
            if (panel) bindPanelTrigger(triggerBtn, panel);
         }

         var simularPanel = doc.getElementById(SIMULAR_PANEL_ID);
         if (!simularPanel) return;

         var bannerBtns = doc.querySelectorAll('.banner-divider__btn');
         for (var b = 0; b < bannerBtns.length; b++) {
            bindPanelTrigger(bannerBtns[b], simularPanel);
         }
      }

      function openSimularFromBanner(btn) {
         var panel = doc.getElementById('simularEmprestimoPanel');
         if (!btn || !panel) return false;

         bindPanelTrigger(btn, panel);
         var target = null;
         for (var i = 0; i < panels.length; i++) {
            if (panels[i].btn === btn && panels[i].panel === panel) {
               target = panels[i];
               break;
            }
         }
         if (!target) return false;

         closeAllPanels(target);
         setPanelOpen(target, true);
         return true;
      }

      scanPanelTriggers();
      window.addEventListener('load', scanPanelTriggers);

      window.addEventListener(
         'resize',
         function () {
            syncSimularDropdownPosition(doc);
         },
         { passive: true }
      );

      doc.addEventListener(
         'click',
         function (e) {
            var bannerBtn = e.target.closest('.banner-divider__btn');
            if (!bannerBtn || bannerBtn.getAttribute('data-mega-bound')) return;
            if (!doc.getElementById('simularEmprestimoPanel')) return;

            e.preventDefault();
            e.stopPropagation();
            openSimularFromBanner(bannerBtn);
         },
         true
      );

      function resetSubDetails(scope) {
         if (!scope) return;
         var details = scope.querySelectorAll('.mega-panel__sub-detail');
         for (var d = 0; d < details.length; d++) details[d].hidden = true;
         var subTriggers = scope.querySelectorAll('[data-subdetail-target]');
         for (var s = 0; s < subTriggers.length; s++) {
            subTriggers[s].classList.remove('is-active');
            subTriggers[s].setAttribute('aria-expanded', 'false');
         }
      }

      function retriggerViewAnimations(view) {
         if (!view) return;
         view.hidden = true;
         void view.offsetWidth;
         view.hidden = false;
      }

      function showMegaView(panel, viewId, options) {
         if (!panel) return;
         options = options || {};
         var views = panel.querySelectorAll('.mega-panel__view');
         var active = null;
         for (var i = 0; i < views.length; i++) {
            var isActive = views[i].id === viewId;
            views[i].hidden = !isActive;
            if (isActive) active = views[i];
         }
         panel.setAttribute('data-active-view', viewId);
         panel.setAttribute('data-user-navigated', 'true');
         markMegaPanelSidebarSelection(panel, viewId);
         resetSubDetails(panel);
         if (!options.skipAnimation) retriggerViewAnimations(active);
      }

      function resetMegaPanelView(panel) {
         resetMegaPanelToInitialState(panel, doc);
      }

      function resetMobileDrawer() {
         if (!els.mobileDrawer) return;
         var opens = els.mobileDrawer.querySelectorAll('details[open]');
         for (var i = 0; i < opens.length; i++) opens[i].open = false;
         var sInput = els.mobileDrawer.querySelector('.header-mobile-drawer__search-input');
         if (sInput) sInput.value = '';
      }

      function setDrawerOpen(open) {
         if (!els.mobileDrawer || !els.mobileToggle) return;
         els.mobileToggle.classList.toggle('is-open', open);
         els.mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
         els.mobileDrawer.hidden = !open;
         els.mobileDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
         els.body.classList.toggle('header-drawer-open', open);
         if (!open) resetMobileDrawer();
         updateOverlay();
         if (open) {
            requestAnimationFrame(function () {
               refreshMobileProductsCarousels();
            });
         }
      }

      if (els.mobileToggle) {
         els.mobileToggle.addEventListener('click', function (e) {
            e.stopPropagation();
            closeAllPanels();
            setDrawerOpen(els.mobileDrawer.hidden);
         });
      }

      if (els.mobileClose) {
         els.mobileClose.addEventListener('click', function () {
            setDrawerOpen(false);
         });
      }

      if (els.mobileDrawer) {
         els.mobileDrawer.addEventListener('click', function (e) {
            var link = e.target.closest('a');
            if (link && els.mobileDrawer.contains(link)) setDrawerOpen(false);
         });
      }

      function setSearchOpen(open) {
         if (!els.headerShell || !els.searchBar) return;
         els.headerShell.classList.toggle('is-search-open', open);
         els.searchBar.hidden = !open;
         var btn = doc.querySelector('[data-search-open]');
         if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
         if (els.searchInput) {
            if (open) setTimeout(function () { els.searchInput.focus(); }, 0);
            else els.searchInput.value = '';
         }
      }

      doc.addEventListener('click', function (e) {
         if (e.target.closest('[data-search-open]')) {
            e.stopImmediatePropagation();
            closeAllPanels();
            setDrawerOpen(false);
            setSearchOpen(true);
         }
      });

      if (els.searchBar) {
         els.searchBar.addEventListener('click', function (e) {
            if (e.target.closest('[data-search-close]')) setSearchOpen(false);
            e.stopPropagation();
         });
      }

      doc.addEventListener('click', function () {
         closeAllPanels();
         setSearchOpen(false);
      });

      if (els.overlay) {
         els.overlay.addEventListener('click', function () {
            closeAllPanels();
            setDrawerOpen(false);
            setSearchOpen(false);
         });
      }

      doc.addEventListener('keydown', function (e) {
         if (e.key === 'Escape') {
            closeAllPanels();
            setDrawerOpen(false);
            setSearchOpen(false);
         }
      });

      var mql = window.matchMedia('(min-width: 1200px)');
      function handleBreakpoint(ev) {
         if (ev.matches) setDrawerOpen(false);
         else closeAllPanels();
      }
      if (mql.addEventListener) mql.addEventListener('change', handleBreakpoint);
      else if (mql.addListener) mql.addListener(handleBreakpoint);

      function initExclusiveAccordions(root) {
         if (!root) return;
         var details = root.querySelectorAll('details[name]');
         var groups = {};
         for (var i = 0; i < details.length; i++) {
            var d = details[i];
            var n = d.getAttribute('name');
            if (!groups[n]) groups[n] = [];
            groups[n].push(d);
         }
         Object.keys(groups).forEach(function (name) {
            var siblings = groups[name];
            siblings.forEach(function (d) {
               d.addEventListener('toggle', function () {
                  if (!d.open) return;
                  siblings.forEach(function (s) {
                     if (s !== d && s.open) s.open = false;
                  });
               });
            });
         });
      }

      initExclusiveAccordions(els.mobileDrawer);

      function initMobileProductsCarousel() {
         var carousels = doc.querySelectorAll('.header-mobile-products');
         var refreshFns = [];

         for (var c = 0; c < carousels.length; c++) {
            (function (root) {
               var viewport = root.querySelector('.header-mobile-products__viewport');
               var dotsHost = root.querySelector('.header-mobile-products__dots');
               if (!viewport || !dotsHost) return;
               var cards = viewport.querySelectorAll('.header-mobile-products__card');
               var prevBtn = root.querySelector('.header-mobile-products__arrow--prev');
               var nextBtn = root.querySelector('.header-mobile-products__arrow--next');
               var navWrap = root.querySelector('.header-mobile-products__nav');
               if (cards.length <= 1) {
                  if (navWrap) navWrap.hidden = true;
                  else dotsHost.hidden = true;
                  return;
               }

               dotsHost.innerHTML = '';
               for (var i = 0; i < cards.length; i++) {
                  var dot = doc.createElement('button');
                  dot.type = 'button';
                  dot.className = 'header-mobile-products__dot';
                  dot.setAttribute('role', 'tab');
                  dot.setAttribute('aria-label', 'Ir para o slide ' + (i + 1));
                  dot.setAttribute('data-index', String(i));
                  dotsHost.appendChild(dot);
               }
               var dots = dotsHost.querySelectorAll('.header-mobile-products__dot');
               var currentIdx = 0;
               var suppressScrollSync = false;

               function setActive(idx) {
                  currentIdx = idx;
                  for (var d = 0; d < dots.length; d++) {
                     var on = d === idx;
                     dots[d].classList.toggle('is-active', on);
                     dots[d].setAttribute('aria-selected', on ? 'true' : 'false');
                  }
                  if (prevBtn) prevBtn.disabled = idx <= 0;
                  if (nextBtn) nextBtn.disabled = idx >= cards.length - 1;
               }

               function activeIndex() {
                  var vpLeft = viewport.getBoundingClientRect().left;
                  var best = 0;
                  var bestDist = Infinity;
                  for (var j = 0; j < cards.length; j++) {
                     var dist = Math.abs(cards[j].getBoundingClientRect().left - vpLeft);
                     if (dist < bestDist) {
                        bestDist = dist;
                        best = j;
                     }
                  }
                  return best;
               }

               function scrollToIndex(idx) {
                  var clamped = Math.max(0, Math.min(cards.length - 1, idx));
                  var target = cards[clamped];
                  if (!target) return;
                  suppressScrollSync = true;
                  var vpRect = viewport.getBoundingClientRect();
                  var cardRect = target.getBoundingClientRect();
                  var nextLeft = viewport.scrollLeft + (cardRect.left - vpRect.left);
                  var maxLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
                  viewport.scrollTo({
                     left: Math.min(Math.max(0, nextLeft), maxLeft),
                     behavior: 'smooth',
                  });
                  setActive(clamped);
                  window.setTimeout(function () {
                     suppressScrollSync = false;
                  }, 450);
               }

               function refreshState() {
                  setActive(activeIndex());
               }

               refreshFns.push(refreshState);

               var raf = 0;
               viewport.addEventListener(
                  'scroll',
                  function () {
                     if (suppressScrollSync) return;
                     if (raf) return;
                     raf = requestAnimationFrame(function () {
                        raf = 0;
                        setActive(activeIndex());
                     });
                  },
                  { passive: true }
               );

               dotsHost.addEventListener('click', function (e) {
                  var btn = e.target.closest('.header-mobile-products__dot');
                  if (!btn) return;
                  scrollToIndex(parseInt(btn.getAttribute('data-index'), 10) || 0);
               });

               if (prevBtn) {
                  prevBtn.addEventListener('click', function () {
                     scrollToIndex(currentIdx - 1);
                  });
               }
               if (nextBtn) {
                  nextBtn.addEventListener('click', function () {
                     scrollToIndex(currentIdx + 1);
                  });
               }

               viewport.addEventListener('keydown', function (e) {
                  if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
                  e.preventDefault();
                  scrollToIndex(currentIdx + (e.key === 'ArrowRight' ? 1 : -1));
               });

               setActive(0);
            })(carousels[c]);
         }

         refreshMobileProductsCarousels = function () {
            for (var r = 0; r < refreshFns.length; r++) refreshFns[r]();
         };

         window.addEventListener(
            'resize',
            function () {
               refreshMobileProductsCarousels();
            },
            { passive: true }
         );
      }

      initMobileProductsCarousel();
      observeDynamicNav(doc);
      scheduleNavActiveState(doc);
   }

   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
   } else {
      init();
   }
})();
